import React from "react";

export interface TableColumn<T> {
  key: string;
  header: string;
  headerAlign?: "left" | "right";
  cellClassName?: string;
  width?: string;
  render: (row: T) => React.ReactNode;
}

interface DataTableProps<T> {
  columns: TableColumn<T>[];
  rows: T[];
  rowKey: (row: T) => string;
}

function DataTable<T>({ columns, rows, rowKey }: DataTableProps<T>) {
  return (
    <div
      className="bg-white rounded-[8px] overflow-hidden"
      style={{ boxShadow: "0px 1px 2px rgba(0,0,0,0.05)" }}
    >
      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-surface-input">
              {columns.map((col) => (
                <th
                  key={col.key}
                  style={col.width ? { width: col.width, minWidth: col.width } : undefined}
                  className={`px-6 py-4 text-[12px] font-medium whitespace-nowrap text-content-heading ${
                    col.headerAlign === "right" ? "text-right" : "text-left"
                  }`}
                >
                  {col.header}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {rows.map((row, i) => (
              <tr
                key={rowKey(row)}
                className={`hover:bg-[#fafaf7] transition-colors ${
                  i > 0 ? "border-t border-[#eeeee5]" : ""
                }`}
              >
                {columns.map((col) => (
                  <td key={col.key} className={col.cellClassName ?? ""}>
                    {col.render(row)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DataTable;
